// components/calculator/PercentageSection.js
import React from 'react';
import { Typography, Grid, TextField } from '@mui/material';

const PercentageSection = ({ formData, setFormData }) => {
  const months = [
    { key: 'porcentajeSep', label: '📅 Septiembre', placeholder: 'Ej: 5' },
    { key: 'porcentajeOct', label: '📅 Octubre', placeholder: 'Ej: 10' },
    { key: 'porcentajeNov', label: '📅 Noviembre', placeholder: 'Ej: 20' },
    { key: 'porcentajeDic', label: '📅 Diciembre', placeholder: 'Ej: 30' },
    { key: 'porcentajeEne', label: '📅 Enero', placeholder: 'Ej: 15' }
  ];

  return (
    <>
      <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
        📈 Porcentajes de Aumento por Mes
      </Typography>
      <Grid container spacing={2}>
        {months.map(({ key, label, placeholder }) => (
          <Grid item xs={12} sm={6} md={2.4} key={key}>
            <TextField
              fullWidth
              type="number"
              label={label}
              value={formData[key]}
              onChange={(e) => setFormData(prev => ({ ...prev, [key]: e.target.value }))}
              placeholder={placeholder}
              InputProps={{
                endAdornment: <Typography variant="body2">%</Typography>
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default PercentageSection;